import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RegionContext = createContext(null);

const REGION_CONFIG = {
  CA: {
    region: 'CA',
    currency: 'CAD',
    currencySymbol: 'CA$',
    postalLabel: 'Postal Code',
    postalPlaceholder: 'A1A 1A1',
    postalPattern: '[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]',
    flag: 'CA',
    label: 'Canada (CAD)',
  },
  US: {
    region: 'US',
    currency: 'USD',
    currencySymbol: '$',
    postalLabel: 'ZIP Code',
    postalPlaceholder: '12345',
    postalPattern: '[0-9]{5}',
    flag: 'US',
    label: 'United States (USD)',
  },
};

export const RegionProvider = ({ children }) => {
  const [region, setRegionState] = useState('CA');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/settings`)
      .then((res) => {
        setRegionState(res.data.region || 'CA');
      })
      .catch(() => setRegionState('CA'))
      .finally(() => setLoading(false));
  }, []);

  const updateRegion = useCallback(async (newRegion) => {
    try {
      const token = localStorage.getItem('adminToken') || localStorage.getItem('staffToken');
      await axios.patch(
        `${API}/admin/settings`,
        { region: newRegion },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRegionState(newRegion);
    } catch (err) {
      console.error('Failed to update region', err);
      throw err;
    }
  }, []);

  const config = REGION_CONFIG[region] || REGION_CONFIG.CA;

  const formatPrice = (amount) => {
    if (amount == null) return '';
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: config.currency,
      minimumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <RegionContext.Provider value={{ ...config, loading, updateRegion, formatPrice }}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = () => {
  const ctx = useContext(RegionContext);
  if (!ctx) throw new Error('useRegion must be used within RegionProvider');
  return ctx;
};

export default RegionContext;
